/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon20Solid = forwardRef('ArrowAUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.5 3.25a1.25 1.25 0 1 0 0 2.5h6.982l-9.366 9.366a1.25 1.25 0 0 0 1.768 1.768l9.366-9.366V14.5a1.25 1.25 0 1 0 2.5 0V6A2.75 2.75 0 0 0 14 3.25H5.5Z" })));
});
